import { useEffect } from 'react';

import { useGET } from 'hooks/useRequest';
import usePricingStore from 'stores/pricing_store/usePricingStore';
import useProductShowStore from 'stores/product_show_store/useProductShowStore';
import ProductPricing from 'components/products/product_pricing';

/**
 * This component will fetch the product price and store within global store
 */
const FetchProductShowPrice = ({
  stepId,
  vatStatus,
  fetchPriceUrl,
  minOrderValue,
  priceBeforeCurrentSale,
  priceBeforeCurrentSaleIncVAT,
  isOnClearance,
  isRedemptionOffer,
}) => {
  const { productPrice, setPrice } = usePricingStore();
  const { setProductBasketQuantity, setProductStock } = useProductShowStore();

  const { data: priceResponse } = useGET(
    `${fetchPriceUrl}?id=${stepId}&quantity=${minOrderValue}`,
  );

  useEffect(() => {
    // Set our price in global store
    if (priceResponse) {
      const {
        product_prices: prices,
        stock_level: stockLevel,
        total_basket_and_requested_quantity: basketQuantity,
      } = priceResponse;

      setPrice(prices);
      setProductStock(stockLevel);
      setProductBasketQuantity(basketQuantity);
    }
  }, [priceResponse]);

  return (
    <ProductPricing
      id={stepId}
      prices={productPrice}
      vatStatus={vatStatus}
      priceBeforeCurrentSale={priceBeforeCurrentSale}
      priceBeforeCurrentSaleIncVAT={priceBeforeCurrentSaleIncVAT}
      isOnClearance={isOnClearance}
      isRedemptionOffer={isRedemptionOffer}
    />
  );
};

export default FetchProductShowPrice;
